import React, {useState} from 'react'
import TenantFeeAddModal from "./TenantFeeAddModal";

function TenantFeeAdd(props) {
    const [isOpen, setIsOpen] = useState(false)

    const _toggleModal = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <span onClick={_toggleModal} className="material-icons cursor-pointer text-primary">add</span>
            {isOpen && <TenantFeeAddModal isOpen={isOpen} toggleModal={_toggleModal} {...props}/>}
        </>
    )
}

export default TenantFeeAdd
